import { useTableConstructor } from "layout/TableConstructor/context/tableConstructorContext";
import Filters from "components/Filters";
import { Identifiable, IFilterProps } from "../../types";

const TableFilters = <T extends Identifiable, AvailableFilters extends object, OrderField extends string>({
  form,
}: IFilterProps<AvailableFilters>) => {
  const { visibleFilterConfig } = useTableConstructor<T, AvailableFilters, OrderField>();

  return (
    <Filters
      // @ts-expect-error типизировать не получается, ошибок быть не должно
      form={form}
      filters={visibleFilterConfig}
    />
  );
};

export default TableFilters;
